// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router'

import JsEncrypt from 'jsencrypt'


//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
 //引入富文本css
// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
//富文本编辑器添加实例
Vue.use(VueQuillEditor, /* { default global options } */)
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/ZxlCss.css';
import '../static/css/css.css';
// 主题色
import '../static/theme/index.css';


import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';



import {setCookie,getCookie,delCookie} from '@/api/cookie.js'
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}
// setCookie( 'userid' ,'1', 36000);

import axios from 'axios'
import api from './api/http.js'
//定义全局变量
Vue.prototype.$api = api;
Vue.config.productionTip = false
/* eslint-disable no-new */

Vue.prototype.$encruption = function (obj) {
  let encrypt = new JsEncrypt()
  encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANDRCngAuUFVEQ9HejhmnU8/73Trz5WZqSkXgBLnovPOP0weRyyrwKS3EfpToeo3oAMJg8UtMKjHoE5tC46GsmMCAwEAAQ==-----END PUBLIC KEY-----')  // 放置自己的公钥
  return encrypt.encrypt(obj)
}





router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)){ // 判断该路由是否需要登录权限
      if (getCookie("userid") == '' || getCookie("userid") == 'undefined' || getCookie("userid") == null){

        Vue.prototype.$confirm('请登录', '未登录', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              next({
                  path: '/',
              })
            }).catch(() => {
               Vue.prototype.$message({
                type: 'info',
                message: '已取消'
              });
            });
      }else {
        next();
      }
  }
  else {
    next();
  }
});






new Vue({
  el: '#app',
  router,
  components: { App },

  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js